import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useDialog } from "lib/@hooks/useDialog"
import { AuthoringDeleteDialog } from "./project-item/authoring-delete-dialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { deleteGroup } from "../controller/delete-group"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { isLockedToLegacy } from "../../../lib/enum/project-phase.mjs"
import { GroupStatus } from "authoring/lib/enum/group-status.mjs"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function DeleteGroup() {
    const { target, group } = useBoundContext()
    const projectId = target?.id
    const disabled = isLockedToLegacy(target?.phase) || group?.status === GroupStatus.APPLIED

    const deleteGroupDialog = useDialog(
        <AuthoringDeleteDialog
            value={group?.id}
            title="Are you sure you want to delete this group?"
            message="You will not be able to undo this action"
        />
    )
    return (
        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
            <ContextMenuItem
                disabled={disabled}
                data-cy="delete-group-button"
                icon="gravity-ui:trash-bin"
                label="Delete"
                onClick={() => removeGroup({ projectId, groupId: group?.id, deleteGroupDialog })}
            />
        </Secure>
    )
}

async function removeGroup({ projectId, groupId, deleteGroupDialog }) {
    try {
        const confirmDeleteGroup = await deleteGroupDialog()
        if (confirmDeleteGroup) {
            const removeGroup = await deleteGroup({ id: projectId, groupId })
            if (removeGroup) {
                successSnackbar("Group successfully deleted.")
            } else {
                errorSnackbar("Failed to delete group.")
            }
        }
    } catch (e) {
        console.error(e)
        errorSnackbar("Failed to delete group.")
    }
}
